<template>
  <label class="label">
    <slot />

    <input
      type="file"
      class="hidden"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </label>
</template>

<script>

export default {
  inheritAttrs: false,
  name: 'FileInput'
}

</script>

<style scoped>

.label { cursor: pointer; }

</style>
